import { useEffect, useRef, useState } from "react"

export const useTextOverflow = () => {
  const textRef = useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const updateOverflowStatus = () => {
      if (textRef.current) {
        setIsOverflowing(
          textRef.current.scrollWidth > textRef.current.clientWidth
        )
      }
    }

    const observer = new ResizeObserver(() => {
      updateOverflowStatus()
    })

    if (textRef.current) {
      observer.observe(textRef.current)
      updateOverflowStatus()
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return { textRef, isOverflowing }
}
